import React, { forwardRef, ReactElement } from 'react'
import { Icon, IconBase, IconWeight } from '@phosphor-icons/react'
import { useTheme } from '../../themes/styled'

const getWeights = (color?: string, ellipseColor?: string) => {
    const svg: ReactElement = (
        <>
            <ellipse
                cx="128.088"
                cy="128.088"
                rx="89.088"
                ry="89.088"
                transform="rotate(-180 128.088 128.088)"
                stroke={ellipseColor}
                strokeWidth="32"
            />
            <path
                d="M38.9999 128.088C38.9999 116.389 41.3042 104.804 45.7813 93.9955C50.2584 83.1868 56.8206 73.3658 65.0932 65.0933C73.3657 56.8207 83.1867 50.2585 93.9954 45.7814C104.804 41.3043 116.389 39 128.088 39"
                stroke={color}
                strokeWidth="32"
            />
        </>
    )
    return new Map<IconWeight, ReactElement>([
        ['regular', svg],
        ['fill', svg],
    ])
}

/**
 * Phosphor custom icon based on https://github.com/phosphor-icons/react#custom-icons
 * Modified how color works to match the icon design
 */
const LoadingSpinner: Icon = forwardRef((props, ref) => {
    const theme = useTheme()
    return (
        <IconBase
            ref={ref}
            {...props}
            weights={getWeights(props.color, theme.colors.indicator.lightGrey)}
            fill="None"
        />
    )
})

LoadingSpinner.displayName = 'LoadingSpinner'

export default LoadingSpinner
